import React from 'react';
import {
  Button,
  Typography,
  Paper,
  Box,
} from '@mui/material';
import { Language as LanguageIcon, ExpandMore } from '@mui/icons-material';
import { useLocale, Language } from '../contexts/LocaleContext';

const LanguageToggle: React.FC = () => {
  const { language, setLanguage } = useLocale();

  const handleToggle = () => {
    const newLanguage: Language = language === 'he' ? 'en' : 'he';
    setLanguage(newLanguage);
  };

  const getCurrentLanguageLabel = () => {
    return language === 'he' ? 'עברית' : 'English';
  };

  const getAlternativeLanguageLabel = () => {
    return language === 'he' ? 'English' : 'עברית';
  };

  return (
    <Paper
      elevation={3}
      sx={{
        position: 'fixed',
        top: { xs: 10, sm: 20 },
        right: { xs: 10, sm: 20 },
        zIndex: 1300,
        borderRadius: 2,
        overflow: 'hidden',
        '@media (max-width: 600px)': {
          position: 'absolute',
          top: 10,
          transform: 'scale(0.85)',
        },
      }}
    >
      <Button
        onClick={handleToggle}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 0.5, sm: 1 },
          px: { xs: 1.5, sm: 2 },
          py: 1,
          borderRadius: 2,
          backgroundColor: 'primary.main',
          color: 'white',
          textTransform: 'none',
          minWidth: { xs: '100px', sm: '120px' },
          '&:hover': {
            backgroundColor: 'primary.dark',
          },
        }}
      >
        <LanguageIcon fontSize="small" />
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1 }}>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              color: 'white',
            }}
          >
            {getCurrentLanguageLabel()}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontSize: { xs: '0.6rem', sm: '0.65rem' },
              color: 'rgba(255, 255, 255, 0.7)',
              textAlign: 'left',
            }}
          >
            → {getAlternativeLanguageLabel()}
          </Typography>
        </Box>
        <ExpandMore fontSize="small" />
      </Button>
    </Paper>
  );
};

export default LanguageToggle;